// image-product-detail-v2 Cuando acabe el test, o veamos que pasa, eliminar este evento
import $ from 'jquery';
import {debounce} from '../../utils.js';

const EVENT_CAROUSEL_SCROLL = 'event-carousel-scroll';
const carouselScrollEventTrigger = () => {
  const event = new CustomEvent(EVENT_CAROUSEL_SCROLL);
	document.querySelectorAll('.carousel-images').forEach(carousel => {
    const images = carousel.querySelectorAll('.carousel-images > img');
    event.countrySeller = document.getElementById('product-sheet')?.
        dataset.biCountrySeller || '';
    event.carouselType = 'new';
    carousel.addEventListener('scroll', debounce(() => {
      images.forEach(async img => {
        if (await isVisible(img, carousel)) {
          event.carouselPosition = img.dataset.position;
          document.dispatchEvent(event);
        }
      });
    }, 500));
  });
};

const isVisible = async (ele, container) => {
  const { left, width, right } = ele.getBoundingClientRect();
  const containerRect = container.getBoundingClientRect();

  return right < containerRect.right ? containerRect.right - right < width :
      left - containerRect.left < width;
};

export {EVENT_CAROUSEL_SCROLL, carouselScrollEventTrigger};